import { getDomainConfig, getLocale } from '@raisin/cp-utils';
export const esMenus = (logoUrl) => {
    const basePath = getDomainConfig(getLocale('es-ES').cmsFormat).basePath;
    return {
        type: 'public',
        logoItems: [
            {
                id: '3f7573d4-7cce-42d0-8263-f0d9079e2b11',
                href: `${basePath}/`,
                url: logoUrl,
                alt: 'Raisin',
            },
        ],
        navItems: [
            {
                id: '7c70fbcc-4e00-4fe1-8b47-87251d3534b5',
                title: 'Productos',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: '9d42c71e-7190-4618-b581-38951fbcf547',
                            type: 'advanced',
                            title: 'Depósitos',
                            href: `${basePath}/depositos-a-plazo-fijo/`,
                            description: 'Inversiones a plazo con tipo de interés fijo',
                            icon: 'overnightMoneyIcon',
                            iconColor: '#9CD3E4',
                        },
                        {
                            id: '76d1f169-c6a1-495e-a495-5fcc74f131ca',
                            type: 'advanced',
                            title: 'Cuentas de ahorro',
                            href: `${basePath}/cuenta-ahorro/`,
                            description: 'Una inversión flexible con tipo de interés variable',
                            icon: 'fixedDepositIcon',
                            iconColor: '#61AFD2',
                        },
                        {
                            id: '7c436554-958b-4bbd-91b7-fa38a9c0dada',
                            type: 'advanced',
                            title: 'Todos los productos',
                            href: `${basePath}/productos/`,
                            description: 'Compara todos los productos que ofrecemos',
                            icon: 'terminationPaymentIcon',
                            iconColor: '#317EA6',
                        },
                    ],
                },
            },
            {
                id: '36e9994f-8c35-4d1c-a470-fab6ad144699',
                title: 'Sobre nosotros',
                href: `${basePath}/acerca-raisin/`,
            },
            {
                id: 'f149e12f-3a9f-44e3-a75e-ae1a37e12c64',
                title: 'Información',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: 'e78780a1-cc15-45d9-95ca-53c52e905cc5',
                            type: 'advanced',
                            title: 'Garantía de depósitos',
                            href: `${basePath}/fondo-garantia-depositos/`,
                            description: 'Todo acerca del sistema de garantía de depósitos',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt0adba2eaeb81e4b1/Garantía_de_depósitos.svg',
                            iconColor: '#0E6CC5',
                        },
                        {
                            id: '2a134210-7e96-4614-b940-318c010b7a0a',
                            type: 'advanced',
                            title: 'Tributación',
                            href: `${basePath}/impuestos/`,
                            description: 'Cómo tributan los productos que contratas a través de Raisin',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt0b0deb0f7f6c3701/Tributación.svg',
                            iconColor: '#0E6CC5',
                        },
                        {
                            id: 'd63e6408-738b-4d6f-927a-bc2274804d69',
                            type: 'advanced',
                            title: 'Bancos',
                            href: `${basePath}/bancos/`,
                            description: 'Conoce nuestros bancos colaboradores',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt017f3eb0e4c93396/Bancos.svg',
                            iconColor: '#0E6CC5',
                        },
                        {
                            id: '5d4de868-91cd-42cc-9358-08173aa5986f',
                            type: 'advanced',
                            title: 'Guía del ahorro',
                            href: `${basePath}/ahorro/`,
                            description: 'Descubre las claves para un mejor ahorro',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltcff737ce31d3d64f/Guía_del_ahorro.svg',
                            iconColor: '#0E6CC5',
                        },
                        {
                            id: '5d4de868-91cd-42cc-9358-08173aa5986f',
                            type: 'advanced',
                            title: 'Guía de la inversión',
                            href: `${basePath}/inversion/`,
                            description: 'Nuestra guía definitiva para invertir dinero',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt7c20b2360d6a5bdf/Guía_de_la_inversión.svg',
                            iconColor: '#0E6CC5',
                        },
                    ],
                    sidebar: [
                        {
                            id: '682a68af-d0c3-4f6f-8aa4-0b4752040b0e',
                            type: 'image',
                            title: 'Contestamos las preguntas clave sobre cómo y por qué ahorrar en Europa',
                            href: `${basePath}/ahorro/ahorrar-en-europa/`,
                            imageUrl: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt2583321398710b00/Image_Ausland.png',
                            description: 'Contestamos las preguntas',
                        },
                        {
                            id: 'f10ea65e-7827-42c9-a681-c0b214aeb11d',
                            type: 'arrow',
                            title: 'Ahorrar en Italia',
                            href: `${basePath}/ahorro/ahorrar-en-europa/italia/`,
                        },
                        {
                            id: '94216326-d1cb-4afe-9e1e-543421f52d57',
                            type: 'arrow',
                            title: 'Ahorrar en Francia',
                            href: `${basePath}/ahorro/ahorrar-en-europa/francia/`,
                        },
                        {
                            id: '0461c3f8-fc6a-4126-8e9a-1331d96a7a38',
                            type: 'arrow',
                            title: 'Ahorrar en España',
                            href: `${basePath}/bancos-espana/`,
                        },
                    ],
                },
            },
            {
                id: 'b1ef9202-f58c-4f98-a3fe-b4178a842ecb',
                title: 'Ayuda',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: 'f7c75a69-3287-483f-912f-d4c2432a0708',
                            type: 'text',
                            title: 'Cómo abrir tu Cuenta Raisin',
                            href: `${basePath}/como-registrarte-en-raisin/`,
                        },
                        {
                            id: 'b16af5c5-2320-4317-80fa-fc2a375eb79c',
                            type: 'text',
                            title: 'Preguntas frecuentes',
                            href: 'https://ayuda.raisin.es/hc/es/',
                        },
                        {
                            id: 'd41882ea-f390-47ed-b94e-3f7a7eea1a33',
                            type: 'text',
                            title: 'Atención al cliente',
                            href: `${basePath}/contacto/`,
                        },
                    ],
                },
            },
        ],
        actionItems: [
            {
                id: '659be2f1-cdfa-4666-bcbb-edf874ad83ce',
                title: 'Acceso clientes',
                href: `${basePath}/login/`,
                type: 'login',
            },
            {
                id: 'fc1573f6-a151-4299-aaef-0e1b375227ba',
                title: 'Hazte cliente',
                href: `${basePath}/register/`,
                type: 'registration',
            },
        ],
    };
};
//# sourceMappingURL=esMenus.js.map